import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { GlobalContext } from 'context/GlobalContext';
import { BrowserRouter as Router, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { toggleDimScreen } from './redux/global.slice';
import LoginPage from './pages/Login';
import { Fragment, useContext, useEffect } from 'react';
import { getMe } from 'network/apis/CommonApi';
import { useQuery } from 'react-query';
import 'core/prototypes';
import Guard from 'components/Guard';
import AdminApp from './admin-app';
import ProvinceApp from './province-app';
import CompanyApp from './company-app';
import AppRoutes from './AppRoutes';
import { useMemo } from 'react';
import { memo } from 'react';

const AppHolder = styled.div`
  font-family: 'YEKAN-BAKH-MEDIUM';
`;

const DimLayer = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100rem;
  display: ${(props) => props.show ? 'block' : 'none'};
  z-index: 222;
`;

function App() {
  const { user } = useContext(GlobalContext);

  const globalState = useSelector((store) => store.global);
  const dispatch = useDispatch(toggleDimScreen());

  const hasUserLoggedIn = () => user != null && user.length > 0;

  const {
    data: userData
  } = useQuery(
    ["get-me"],
    () => getMe(user),
    {
      refetchOnWindowFocus: false,
      enabled: hasUserLoggedIn(),
    }
  );

  useEffect(() => {
    const userFullName = userData?.full_name;
    if (userFullName) localStorage.setItem('user_full_name', userFullName);
  }, [userData]);

  const AppRoutesMemo = memo(AppRoutes);

  return (
    <AppHolder>
      <DimLayer show={globalState.dimScreen} onClick={() => dispatch(toggleDimScreen())} />
      <Router>
        <Routes>
          <Route path="*" element={<AppRoutesMemo />} />
        </Routes>
      </Router>
      <ToastContainer />
    </AppHolder>
  );
}

export default App;
